export const isPhoneNumberPartiallyValid = (phoneNumber: string) => {
  const regexp = new RegExp(/^[\d\u06F0-\u06F9]{0,11}$/);
  if (regexp.test(phoneNumber)) return true;
  return false;
};
